import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $rollback,
  mounted,
  rollbackTransactionRequest,
  unmounted,
} from './model'

export const useRollback = () => {
  const rollback = useStore($rollback)
  const isLoading = useStore(rollbackTransactionRequest.pending)

  React.useEffect(() => {
    mounted()
    return () => unmounted()
  }, [])

  return { rollback, isLoading }
}
